module.exports = __webpack_public_path__ + "static/TiemposTextWeb-RegularItalic-0980024ae4eea8e7c2d7c81ad1e49b3f.woff2";